export const isFromEnum = (e) => 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(token) => Object.values(e).includes(token);
